import React from "react";
import { useMutation } from "@apollo/client";
import { Button, message } from "antd";

import { CREATE_ENDPOINT_MUTATION, ENDPOINT_QUERY } from "../../helpers/graphql/endpoint";
import { PROJECTS_QUERY } from "../../helpers/graphql/project";

interface Props {
  project: { id: string };
  chain: string;
  network: string;
  archive: boolean;
  websocket: boolean;
  callback?: () => void;
}

export function CreateEndpoint({ project, chain, network, archive, websocket, callback = () => {} }: Props) {
  const [createEndpoint, { loading }] = useMutation(CREATE_ENDPOINT_MUTATION, {
    onCompleted: ({ createEndpoint }) => {
      if (createEndpoint) {
        message.success(`${websocket ? 'Websocket' : 'RPC'} endpoint created!`);
        callback();
      }
    },

    refetchQueries: ({ data }) => [
      {
        query: ENDPOINT_QUERY,
        variables: {
          projectId: data.createEndpoint.projectId,
          chain: data.createEndpoint.chain,
          network: data.createEndpoint.network,
        },
        errorPolicy: "all",
      },
      {
        query: PROJECTS_QUERY,
      },
    ],
  });

  const handleSubmit = async () => {
    createEndpoint({ variables: { projectId: project.id, chain, network, archive, websocket } });
  };

  return (
    <Button type="primary" loading={loading} onClick={handleSubmit}>
      Request Endpoint
    </Button>
  );
}
